module.exports = __webpack_public_path__ + "img/23.8cd0e673.png";